window.lib = window.lib || {};
window.images = window.images || {};
window.ss = window.ss || {};
(function (lib, img, ss, cjs, an) {

var p; // shortcut to reference prototypes

lib.ssMetadata = [];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:
// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.TextSamplesSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// WorkSans 150
	this.text = new cjs.Text("Font", "150px 'Work Sans'", "#FFFFFF");
	this.text.lineHeight = 217;
	this.text.lineWidth = 486;
	this.text.parent = this;
	this.text.setTransform(83.8,33.4);
ranj.TextOffsetFixer.fix(this.text);

	this.timeline.addTween(cjs.Tween.get(this.text).wait(1));

	// WorkSans 90
	this.text_1 = new cjs.Text("Font", "90px 'Work Sans'", "#FFFFFF");
	this.text_1.lineHeight = 130;
	this.text_1.lineWidth = 275;
	this.text_1.parent = this;
	this.text_1.setTransform(90.3,60);
ranj.TextOffsetFixer.fix(this.text_1);

	this.timeline.addTween(cjs.Tween.get(this.text_1).wait(1));

	// WorkSans 60
	this.text_2 = new cjs.Text("Font", "60px 'Work Sans'", "#FFFFFF");
	this.text_2.lineHeight = 87;
	this.text_2.lineWidth = 275;
	this.text_2.parent = this;
	this.text_2.setTransform(93.5,73.35);
ranj.TextOffsetFixer.fix(this.text_2);

	this.timeline.addTween(cjs.Tween.get(this.text_2).wait(1));

	// WorkSans 30
	this.text_3 = new cjs.Text("Font", "30px 'Work Sans'", "#FFFFFF");
	this.text_3.lineHeight = 43;
	this.text_3.lineWidth = 87;
	this.text_3.parent = this;
	this.text_3.setTransform(96.8,86.7);
ranj.TextOffsetFixer.fix(this.text_3);

	this.timeline.addTween(cjs.Tween.get(this.text_3).wait(1));

	// OpenSans Bold 30
	this.text_4 = new cjs.Text("Font", "bold 30px 'Open Sans'");
	this.text_4.lineHeight = 41;
	this.text_4.lineWidth = 218;
	this.text_4.parent = this;
	this.text_4.setTransform(97.35,89.45);
ranj.TextOffsetFixer.fix(this.text_4);

	this.timeline.addTween(cjs.Tween.get(this.text_4).wait(1));

	// OpenSans Bold 60
	this.text_5 = new cjs.Text("Font", "bold 60px 'Open Sans'");
	this.text_5.lineHeight = 82;
	this.text_5.lineWidth = 218;
	this.text_5.parent = this;
	this.text_5.setTransform(94.6,78.85);
ranj.TextOffsetFixer.fix(this.text_5);

	this.timeline.addTween(cjs.Tween.get(this.text_5).wait(1));

	// OpenSans Bold 90
	this.text_6 = new cjs.Text("Font", "bold 90px 'Open Sans'");
	this.text_6.lineHeight = 123;
	this.text_6.lineWidth = 218;
	this.text_6.parent = this;
	this.text_6.setTransform(92,68.3);
ranj.TextOffsetFixer.fix(this.text_6);

	this.timeline.addTween(cjs.Tween.get(this.text_6).wait(1));

	// OpenSans Bold 120
	this.text_7 = new cjs.Text("Font", "bold 120px 'Open Sans'");
	this.text_7.lineHeight = 163;
	this.text_7.lineWidth = 421;
	this.text_7.parent = this;
	this.text_7.setTransform(89.3,57.55);
ranj.TextOffsetFixer.fix(this.text_7);

	this.timeline.addTween(cjs.Tween.get(this.text_7).wait(1));

	// OpenSans copy
	this.os30 = new cjs.Text("Font ", "30px 'Arial'", "#0000FF");
	this.os30.name = "os30";
	this.os30.lineHeight = 41;
	this.os30.lineWidth = 93;
	this.os30.parent = this;
	this.os30.setTransform(97.0953,89.2);
ranj.TextOffsetFixer.fix(this.os30);

	this.timeline.addTween(cjs.Tween.get(this.os30).wait(1));

	// OpenSans copy 2
	this.os90 = new cjs.Text("Font", "90px 'Arial'", "#00FF00");
	this.os90.name = "os90";
	this.os90.lineHeight = 123;
	this.os90.lineWidth = 308;
	this.os90.parent = this;
	this.os90.setTransform(91.3,67.9);
ranj.TextOffsetFixer.fix(this.os90);

	this.timeline.addTween(cjs.Tween.get(this.os90).wait(1));

	// OpenSans
	this.os60 = new cjs.Text("Font ", "60px 'Arial'");
	this.os60.name = "os60";
	this.os60.lineHeight = 82;
	this.os60.lineWidth = 282;
	this.os60.parent = this;
	this.os60.setTransform(94.2453,78.65);
ranj.TextOffsetFixer.fix(this.os60);

	this.timeline.addTween(cjs.Tween.get(this.os60).wait(1));

	// OpenSans copy 4
	this.os120 = new cjs.Text("Font", "120px 'Arial'", "#FF0000");
	this.os120.name = "os120";
	this.os120.lineHeight = 163;
	this.os120.lineWidth = 353;
	this.os120.parent = this;
	this.os120.setTransform(88.25,57.3);
ranj.TextOffsetFixer.fix(this.os120);

	this.timeline.addTween(cjs.Tween.get(this.os120).wait(1));

	// OpenSans copy 3
	this.os150 = new cjs.Text("Font", "150px 'Open Sans'", "#FF00FF");
	this.os150.name = "os150";
	this.os150.lineHeight = 204;
	this.os150.lineWidth = 353;
	this.os150.parent = this;
	this.os150.setTransform(85.45,46.9);
ranj.TextOffsetFixer.fix(this.os150);

	this.timeline.addTween(cjs.Tween.get(this.os150).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TextSamplesSkin, new cjs.Rectangle(49,31.4,1374.4,993.6), null);


// stage content:
(lib.TextPositioningAssets = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// TextSamplesSkin
	this.instance = new lib.TextSamplesSkin();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(1041.8,571.4,-469.9,-101.59999999999997);
// library properties:
lib.properties = {
	id: '2D758ABF18A3194E856740076AC96F36',
	width: 1920,
	height: 1080,
	fps: 60,
	color: "#999999",
	opacity: 1.00,
	manifest: [],
	preloads: []
};



an.handleFilterCache = function(event) {
	if(!event.paused){
		var target = event.target;
		if(target){
			if(target.filterCacheList){
				for(var index = 0; index < target.filterCacheList.length ; index++){
					var cacheInst = target.filterCacheList[index];
					if((cacheInst.startFrame <= target.currentFrame) && (target.currentFrame <= cacheInst.endFrame)){
						cacheInst.instance.cache(cacheInst.x, cacheInst.y, cacheInst.w, cacheInst.h);
					}
				}
			}
		}
	}
}


})(lib.TextPositioningAssets = {}, images, ss, createjs, AdobeAn = AdobeAn||{});
var AdobeAn;
module.exports = lib.TextPositioningAssets;